import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_ENABLED_SERIES_ENTRY = '[SERIES_ENTRY] GET ENABLED SERIES ENTRY'
export const ENABLING_SERIES_ENTRY = '[SERIES_ENTRY] ENABLING SERIES ENTRY'
export const FINISH_SERIES_ENTRY = '[SERIES_ENTRY] FINISH SERIES ENTRY'

export function getEnabledSeriesEntryAction() {
  const request = api.get(`/series-entry/enabled`)
  return (dispatch) => {
    dispatch({ type: GET_ENABLED_SERIES_ENTRY, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_ENABLED_SERIES_ENTRY, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_ENABLED_SERIES_ENTRY, error)
    }).finally(() => {
      dispatch({ type: GET_ENABLED_SERIES_ENTRY, payload: { loading: false } })
    })
  }
}

export function enableSeriesEntryAction(data) {
  const request = api.post(`/series-entry/enable`, data)
  return (dispatch) => {
    dispatch({ type: ENABLING_SERIES_ENTRY, payload: { enabling: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(ENABLING_SERIES_ENTRY, error)
    }).finally(() => {
      dispatch({ type: ENABLING_SERIES_ENTRY, payload: { enabling: false } })
    })
  }
}

export function finishSeriesEntryAction(serieEntryId) {
  const request = api.post(`/series-entry/${serieEntryId}/finish`)
  return (dispatch) => {
    dispatch({ type: FINISH_SERIES_ENTRY, payload: { finishing_id: serieEntryId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: FINISH_SERIES_ENTRY, payload: { finished_id: serieEntryId } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(FINISH_SERIES_ENTRY, error)
    }).finally(() => {
      dispatch({ type: FINISH_SERIES_ENTRY, payload: { finishing_id: serieEntryId } })
    })
  }
}